
// detect scroll direction
let lastScrollTop = 0;
// throttle
let direction = -1; // 1 == down, 0 == up

$(window).scroll(function (event) {
    let scrollTop = $(this).scrollTop();
    let navBarElement = $('.header');
    let navBarHeight = navBarElement.height();
    // scrolling outside navBar
    if (scrollTop > navBarHeight) {
        if (scrollTop > lastScrollTop) {
            // downScroll code
            if (direction !== 1){
                direction = 1;
                $(document).trigger("scrolldirectionchange", ["down"])
            }
        } else {
            // upScroll code
            if (direction !== 0) {
                direction = 0;
                $(document).trigger("scrolldirectionchange", ["up"])
            }
        }
    }
    lastScrollTop = scrollTop;
});
